import ENV from './env'

export default () => {
  const { name, project } = ENV
  document.body.classList.add(project)
  document.title = `${name} — ${document.title}`
}
